/* istanbul ignore file */
import React from 'react';
import { DefaultInputPropTypes, TextInput } from 'framework/form';
import RelationInput from './RelationInput';

const FamilyMemberInput = (props: DefaultInputPropTypes<any>) => {
  return <RelationInput relationInput={TextInput} {...props} />;
};

export default FamilyMemberInput;
